import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine, Cell } from 'recharts'
import { FARMS, COLORS, band } from '../utils/RiversafeUtils.js';
import '../assets/styles/RiverSafeDashboard.css';

const mean = arr => arr.reduce((a,b)=>a+b,0)/arr.length

function Droplet({ score, size=96 }){
  const color = COLORS[band(score)]
  const id = `grad-${band(score)}-${size}-${score}`
  return (
    <svg width={size} height={size} viewBox="0 0 64 64">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} /><stop offset="100%" stopColor={color} />
        </linearGradient>
      </defs>
      <path d="M32 4 C24 16 14 26 14 38 C14 50 22 58 32 58 C42 58 50 50 50 38 C50 26 40 16 32 4 Z" fill={`url(#${id})`} stroke={color} strokeWidth="1.5" />
      <text x="32" y="40" textAnchor="middle" fontSize="16" fontWeight="700" fill="#fff">{score}</text>
    </svg>
  )
}

function FarmCard({ code, score }){
  const navigate = useNavigate()
  return (
    <button onClick={()=>navigate(`/riversafeportfolio/farm/${code}`)} className="farm-card">
      <Droplet score={score} />
      <div className="farm-card-info">
        <div className="farm-label">Farm</div>
        <div className="farm-name">{code}</div>
        <div style={{marginTop:'0.5rem', fontSize:'0.875rem', color:'#555'}}>RiverSafe Score</div>
      </div>
      <div className="farm-card-score">{score}</div>
    </button>
  )
}

function Legend(){
  return (
    <div className="legend">
      <div className="legend-item"><span style={{width:'1rem', height:'1rem', borderRadius:'50%', backgroundColor: COLORS.exemplary}}></span>90–100 Exemplary</div>
      <div className="legend-item"><span style={{width:'1rem', height:'1rem', borderRadius:'50%', backgroundColor: COLORS.balanced}}></span>70–89 Balanced</div>
      <div className="legend-item"><span style={{width:'1rem', height:'1rem', borderRadius:'50%', backgroundColor: COLORS.needs}}></span>50–69 Needs improvement</div>
      <div className="legend-item"><span style={{width:'1rem', height:'1rem', borderRadius:'50%', backgroundColor: COLORS.risk}}></span>0–49 At risk</div>
    </div>
  )
}

export default function Portfolio(){
  const avg = useMemo(()=> mean(FARMS.map(f=>f.score)),[])
  const chartData = FARMS.map(d=>({ name: d.code.replace('X10AI_FT_',''), score: d.score, color: COLORS[band(d.score)] }))

  return (
    <div className="portfolio-container">
      <header className="header-flex">
        <div className="header-left">
          <h1>RiverSafe Score — FarmTwin Pilot</h1>
          <p>A single, clear water quality metric for ABP/Sainsbury’s — <span style={{color:'#007acc'}}>Clean River Beef</span>.</p>
        </div>
        <div className="card">
          <div style={{fontSize:'0.75rem', color:'#555'}}>Portfolio Mean</div>
          <div style={{fontSize:'2rem', fontWeight:'700'}}>{avg.toFixed(1)}</div>
        </div>
      </header>

      <Legend />

      <div className="farm-grid">
        {FARMS.map(f => <FarmCard key={f.code} code={f.code} score={f.score} />)}
      </div>

      <div className="card">
        <h3>Score Distribution</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData}>
            <XAxis dataKey="name" stroke="#555" />
            <YAxis stroke="#555" domain={[0, 100]} />
            <Tooltip />
            <Bar dataKey="score" radius={[8,8,0,0]}>
              {chartData.map((entry,i)=><Cell key={i} fill={entry.color}/>)}
            </Bar>
            <ReferenceLine y={avg} stroke="#007acc" strokeDasharray="4 4"/>
          </BarChart>
        </ResponsiveContainer>
      </div>

      <footer>© {new Date().getFullYear()} x10AI • RiverSafe™ — “Clean River Beef”</footer>
    </div>
  )
}
